export const activities = [
  {
    name: "Mindfull Cooking Workshop",
    description:
      "Change your relationship with food and eating. Get to know centry-old recipes",
    image: "cooking.png",
  },
  {
    name: "Nature Walks",
    description:
      "Embark on immersive journeys in lush landscapes, reconnect with the natural world.",
    image: "nature.png",
  },
  {
    name: "Stargazing",
    description:
      "Lose yourself in the wonders of the night sky, marveling at the cosmic dance of stars.",
    image: "stargazing.png",
  },
  {
    name: "Herbal Medicine Workshop",
    description:
      "Discover nature's healing powers through herbs. Learn how to make basic remedies.",
    image: "medicine.png",
  },
  {
    name: "Farm-to-Table Experience",
    description:
      "Harvest, plant, prep or watch you can be our kitchen guest on any day of your stay",
    image: "farm.png",
  },
  {
    name: "Sustainability Workshop",
    description:
      "Explore practical tips and innovative solutions for a green eco-conscious lifestyle.",
    image: "workshop.png",
  },
];
